import { getOrganizationsWithContainers } from '../services/organization';
import { LOAD_BRANDFOLDERS } from './brandfolder';
import { LOAD_COLLECTIONS } from './collection';

export const LOADING_ORGANIZATION = 'LOADING_ORGANIZATION';
export const LOAD_ORGANIZATIONS = 'LOAD_ORGANIZATIONS';

export const loadingOrganization = loading => ({
  type: LOADING_ORGANIZATION,
  loading
});

export const loadOrganizationsWithContainers = () => dispatch => {
  dispatch(loadingOrganization(true));
  getOrganizationsWithContainers().then(organizations => {
    dispatch({
      type: LOAD_ORGANIZATIONS,
      organizations
    });

    dispatch({
      type: LOAD_BRANDFOLDERS,
      brandfolders: organizations.reduce((allBrandfolders, organization) => ([...allBrandfolders, ...organization.brandfolders]), [])
    });

    dispatch({
      type: LOAD_COLLECTIONS,
      collections: organizations.reduce((allCollections, organization) => ([...allCollections, ...organization.collections]), [])
    });
  });
};



// WEBPACK FOOTER //
// ./src/actions/organization.js